export default "__VITE_ASSET__Bs1P0ZkG__"